import { MobileLoginModalComponent } from "./../mobile-login-modal/mobile-login-modal.component";
import { noBoundsModal } from "./noBounds.component";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

export function ShownoBoundsModal(
    modalService: NgbModal,
    mobileMode = "desktop",
    provider:any
): Promise<any> {
    const mobile = mobileMode != "desktop";
    const component = noBoundsModal;// mobile ? MobileLoginModalComponent : LoginModal;
    const windowClass = "dark-modal" + (mobile ? " mobile" : "");
    let m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "sm",
        centered: true,
        windowClass: windowClass
    });
    let modal = <noBoundsModal>m.componentInstance;
    
    modal.provider = provider;
    
    return m.result;
}
